import { useContextEnsuringProvider } from '@iheartjane/utils';
import isUndefined from 'lodash-es/isUndefined';
import type { ReactNode } from 'react';
import { createContext, useMemo } from 'react';

import { useFacets } from '@jane/dm/internal';
import { getJaneDeviceId } from '@jane/shared/util';

import type { MenuContextProps } from './menuProvider.types';

const MenuContext = createContext<MenuContextProps | null>(null);
MenuContext.displayName = 'Menu';

export const useMenu = () => useContextEnsuringProvider(MenuContext);

interface MenuProviderProps {
  children: ReactNode;
  value: MenuContextProps;
}

export const MenuProvider = ({ children, value }: MenuProviderProps) => {
  const { store } = value;
  const jdid = getJaneDeviceId();

  const { facets, isLoading } = useFacets({
    storeId: Number(store?.id),
    enabled: !isUndefined(store?.id),
  });

  const contextValue = useMemo<MenuContextProps>(
    () => ({
      ...value,
      loading: isLoading || value.loading,
      facets,
      jdid,
    }),
    [facets, isLoading, value, jdid]
  );

  return (
    <MenuContext.Provider value={contextValue}>{children}</MenuContext.Provider>
  );
};
